import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Lock, MessageCircle } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

const LINKS = [
  { id: "manifesto", label: "Cos'è", testid: "nav-link-manifesto" },
  { id: "percorsi", label: "Separazione, Figli, Costi", testid: "nav-link-separazione" },
  { id: "chi-sono", label: "Chi sono", testid: "nav-link-chi-sono" },
  { id: "faq", label: "FAQ", testid: "nav-link-faq" },
  { id: "materiale", label: "Materiale", testid: "nav-link-materiale" },
  { id: "contatti", label: "Contatti", testid: "nav-link-contatti" },
];

export const HeaderNav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header data-testid="header-navigation" className="fixed top-0 inset-x-0 z-50 bg-paper/85 backdrop-blur-md border-b border-ink/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} data-testid="nav-logo-brand" className="flex items-center gap-3 focus-gold rounded-md">
          <img src="/assets/logo.png" alt="Oltre il Conflitto — Mediazione Familiare" className="h-11 w-11 object-cover rounded-full ring-1 ring-ink/10" />
          <span className="text-left leading-tight">
            <span className="block font-serif font-semibold text-ink tracking-wide text-sm sm:text-base">OLTRE IL CONFLITTO</span>
            <span className="block font-display text-[10px] sm:text-xs tracking-[0.2em] text-mist">MEDIAZIONE FAMILIARE · CROTONE</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={l.testid} onClick={() => go(l.id)}
              className="text-sm font-medium text-ink/80 hover:text-golddeep transition-colors duration-300 focus-gold rounded-sm">
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <a href="https://wa.me/393296330445" target="_blank" rel="noopener noreferrer" data-testid="nav-whatsapp-button"
            className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-ink border border-ink/20 rounded-full px-4 py-2 hover:border-gold hover:text-golddeep transition-colors duration-300">
            <MessageCircle size={16} /> WhatsApp
          </a>
          <button onClick={() => go("contatti")} data-testid="nav-cta-colloquio"
            className="hidden sm:inline-flex items-center rounded-full bg-ink text-paper text-sm font-semibold px-5 py-2.5 hover:bg-night hover:-translate-y-0.5 active:scale-95 transition-all duration-300">
            Prenota un colloquio
          </button>
          <Link to="/admin" data-testid="nav-admin-login-button" aria-label="Area riservata"
            className="inline-flex items-center justify-center w-10 h-10 rounded-full text-mist hover:text-golddeep hover:bg-sand transition-colors duration-300">
            <Lock size={17} />
          </Link>
          <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu"
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full text-ink hover:bg-sand transition-colors">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-ink/10 bg-paper px-6 py-4 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`${l.testid}-mobile`} onClick={() => go(l.id)}
              className="text-left py-3 text-base font-medium text-ink border-b border-ink/5 last:border-0">
              {l.label}
            </button>
          ))}
          <button onClick={() => go("contatti")} data-testid="nav-cta-colloquio-mobile"
            className="mt-3 rounded-full bg-ink text-paper font-semibold px-5 py-3 text-center">
            Prenota un colloquio
          </button>
        </div>
      )}
    </header>
  );
};
